<template lang="pug">
.mt-4
  h2 Exporteren
  p Selecteer welke exportmodule je wil activeren. De aanvragen worden hiermee tevens geëxporteerd naar je gewenste CRM-systeem. Indien je gewenste export hier niet tussen staan dan kan je <a href=mailto:info@dealerfinanceservices.nl>een verzoek indienen</a>.

  v-divider.mb-4.mt-4

  v-menu(offset-y, v-if='maexAllowed')
    v-btn(slot='activator', color='primary')
      b.white--text Export methode toevoegen
      v-icon.ml-3 fa fa-chevron-down
    v-list
      v-list-tile(@click='addExportMethod(exportMethodsEnum.MaexFtp.method)', v-if='maexAllowed')
        v-list-tile-title {{ exportMethodsEnum.MaexFtp.text }}
      //- v-list-tile(@click='addExportMethod(exportMethodsEnum.Email.method)')
        v-list-tile-title {{ exportMethodsEnum.Email.text }}
      //- v-list-tile(@click='addExportMethod("ftp")')
        v-list-tile-title Upload naar eigen FTP server

  v-layout.ma-1(align-top, wrap, justify-center)
    b.mt-5(v-if='exportMethods.length === 0') Er zijn nog geen exports toegevoegd.

    v-card.flex-grow-1.mt-4(v-for='(ex, i) in exportMethods', :key='"exportMethod" + i')
      v-layout.pa-4(column, fill-height)
        ExportFtpMaex(v-if='ex.method === exportMethodsEnum.MaexFtp.method', :value='exportMethods[i]', @input='setExportMethod(i, $event)', @valid='setExportMethodValid(i, $event)')
        //- ExportEmail(v-if='ex.method === exportMethodsEnum.Email.method', :value='exportMethods[i]', @input='setExportMethod(i, $event)', @valid='setExportMethodValid(i, $event)')
        //- ExportFtp(v-if='ex.method === "ftp"', :value='exportMethods[i]', @input='setExportMethod(i, $event)', @valid='setExportMethodValid(i, $event)')

        v-layout(justify-end)
          v-btn(color='error', flat, @click='removeMethod(i)')
            v-icon.mr-2 fa fa-trash-alt
            | Verwijderen

</template>

<script>
import { exportMethodsEnum } from '@/helpers/constants'

export default {
  components: {
    ExportEmail: require('./ExportMethods/Email').default,
    ExportFtpMaex: require('./ExportMethods/FtpMaex').default,
    ExportFtp: require('./ExportMethods/Ftp').default
  },

  data () {
    return {
      loading: false,

      exportMethods: [],

      exportMethodsValid: {},

      exportMethodsEnum
    }
  },

  computed: {
    maexAllowed () {
      return !this.exportMethods.some(x => x.method === exportMethodsEnum.MaexFtp.method) // TODO validate this on server
    }
  },

  methods: {
    addExportMethod (method) {
      const exportMethods = this.exportMethods

      exportMethods.push({
        method
      })

      this.exportMethods = exportMethods
    },

    removeMethod (i) {
      this.exportMethods.splice(i, 1)

      this.$delete(this.exportMethodsValid, i)
    },

    setExportMethod (i, v) {
      const exportMethods = this.exportMethods

      exportMethods.splice(i, 1, v)

      this.exportMethods = exportMethods
    },

    setExportMethodValid (i, v) {
      this.$set(this.exportMethodsValid, i, v)
    },

    async save () {
      if (this.$v.$invalid) return

      this.loading = true

      try {
        const variables = {
          orgId: this.$store.state.organization.currentOrgId,
          exportMethods: this.exportMethods
        }

        await this.$store.dispatch('graphqlMutation', {
          name: 'setExportSettings',
          variables,
          deleteCacheQueries: ['getOrganization']
        })

        this.$root.$snackbar.show('Exports zijn aangepast')
      } catch (error) {
        this.$root.$snackbar.show('Exports zijn NIET aangepast')
      }

      this.loading = false
    }
  },

  validations: {
    exportMethodsValid: {
      allValid: (v) => {
        return Object.values(v).every(x => x)
      }
    }
  },

  created () {
    this.exportMethods = JSON.parse(JSON.stringify(this.$store.state.organization.current.exportMethods)) // Need to lose reference for sub components

    for (const key of ['exportMethods']) {
      this.$watch(key, () => {
        this.$root.$save.show(this.save, null)
      }, { deep: true })
    }
    this.$watch('$v.$invalid', (v) => this.$root.$save.setValid(!v), { deep: true }) // Must be last
  }
}
</script>

<style lang="scss" scoped>
</style>
